module.exports = __webpack_public_path__ + "67620311752efed38cb87e63991b589e.png";